import React from "react";
import { kitDigitalCardProps } from "../types/appTypes";

const KitDigitalCard: React.FC<kitDigitalCardProps> = ({
  title,
  descriptionTop,
  descriptionBottom,
  text,
  price,
  icon,
}) => {
  return (
    <div className="bg-white/10 backdrop-blur-md text-white relative w-full h-full p-6 rounded-2xl flex flex-col items-center justify-between border border-white/20 shadow-xl hover:shadow-2xl hover:scale-105 transition-all duration-300">
      <div className="flex flex-col items-center">
        <img src={icon} alt={title} className="w-20 h-20 mb-4" />
        <h4 className="mb-2 text-center text-white">{title}</h4>
      </div>
      <div className="flex-grow">
        <p className="text-sm text-gray-200 font-thin mb-3">{descriptionTop}</p>
        <p className="text-sm mb-4 text-gray-300 font-thin">{descriptionBottom}</p>
      </div>
      <div className="flex flex-col items-center border-t border-white/20 pt-4 w-full">
        <p className="text-lg font-semibold text-yellow-400">{text}</p>
        <p className="text-2xl font-bold text-white">{price}</p>
      </div>
    </div>
  );
};

export default KitDigitalCard;

